module.exports = __webpack_public_path__ + "assets/img/loading-black-32.8dd87ae.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/loading-black-32.gif
// module id = Ojax
// module chunks = 0